var _rect, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5938 7.375H5.40625C4.63244 7.375 4 8.00466 4 8.78125V17.2188C4 17.9956 4.63284 18.625 5.40625 18.625H18.5938C19.3676 18.625 20 17.9953 20 17.2188V8.78125C20 8.00447 19.3673 7.375 18.5938 7.375ZM18.3778 8.3125C17.9232 8.76866 12.5827 14.1266 12.3632 14.3467C12.18 14.5305 11.8201 14.5306 11.6368 14.3467L5.62219 8.3125H18.3778ZM4.9375 17.0464V8.95359L8.97078 13L4.9375 17.0464ZM5.62219 17.6875L9.63263 13.664L10.9728 15.0085C11.522 15.5595 12.4783 15.5593 13.0273 15.0085L14.3674 13.664L18.3778 17.6875H5.62219ZM19.0625 17.0464L15.0292 13L19.0625 8.95359V17.0464Z",
    fill: "#3A2CA0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.625,
    cy: 7.625,
    r: 3.125,
    fill: "#FE4F1A",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.167cf79ab9d5163f37b31135f18c3200.svg";
export { ForwardRef as ReactComponent };